<template>
    <div
        v-if="!isPreview"
        class="minimize-button"
        :title="t('minimize')"
        @click="minimize"
        @keydown.enter="minimize"
    >
        <icon-minus v-if="isChatStyleFlat" />
        <close-icon v-else />
    </div>
</template>

<script setup lang="ts">
    import useWidgetState, { State } from '@/composables/useWidgetState';
    import useConfiguration from '@/composables/useConfiguration';
    import IconMinus from '@/assets/icons/minus.svg?component';
    import CloseIcon from '@/assets/icons/close.svg?component';
    import { useI18n } from 'vue-i18n';
    import messages from './MobileMinimizeButton.messages.json';
    import useWidgetAppearance from '@/composables/useWidgetAppearance';

    const { isChatStyleFlat } = useWidgetAppearance();
    const { t } = useI18n({ messages });
    const { state } = useWidgetState();
    const { isPreview } = useConfiguration();

    function minimize() {
        state.value = State.Minimized;
    }
</script>

<style scoped lang="scss">
    .minimize-button {
        position: absolute;
        top: 0;
        right: 0;
        margin: .5rem;
        cursor: pointer;

        &:hover, &:active {
            transform: scale(.95);
        }

        svg {
            width: 2rem;
        }
    }
</style>
